import {Component, Inject, OnInit} from '@angular/core';
import {Contract} from '../../../shared/interface/contract';
import {InsuranceCompany} from '../../../shared/interface/insurance-company';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {InsuranceCompanyService} from '../../../shared/services/insurance-company.service';
import {ContractService} from '../../../shared/services/contract.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {UtilsService} from '../../../shared/services/utils.service';
import {CountedAndPaginated} from '../../../shared/interface/response/counted-and-paginated';
import {ContractInsuranceCompany} from '../../../shared/interface/contract-insurance-company';
import {HttpErrorResponse} from '@angular/common/http';
import {
  ContractInsuranceCompaniesAddDialogData
} from '../contract-insurance-companies-add-dialog/contract-insurance-companies-add-dialog.component';
import {INSURANCE_TYPE_ASSETS, INSURANCE_TYPE_LIFE} from '../../../shared/services/dict.service';

export interface ContractInsuranceCompaniesSelectDialogData {
  contractObject: Contract;
}

@Component({
  selector: 'app-contract-insurance-companies-select-dialog',
  templateUrl: './contract-insurance-companies-select-dialog.component.html',
  styleUrls: ['./contract-insurance-companies-select-dialog.component.scss']
})
export class ContractInsuranceCompaniesSelectDialogComponent {

  readonly INSURANCE_TYPE_LIFE = INSURANCE_TYPE_LIFE;
  readonly INSURANCE_TYPE_ASSETS = INSURANCE_TYPE_ASSETS;

  contractObject: Contract;
  currentInsuranceCompanyIds: number[] = [];
  toCheckInsuranceCompanyIds: number[] = [];
  insuranceCompanies: InsuranceCompany[] = [];
  contractInsuranceCompaniesForm: FormGroup;
  insuranceCompaniesControl: FormControl;
  processingRequest = false;
  assetsInsuranceCompanies: Array<InsuranceCompany[]> = [];
  lifeInsuranceCompanies: Array<InsuranceCompany[]> = [];

  constructor(
    public dialogRef: MatDialogRef<ContractInsuranceCompaniesSelectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ContractInsuranceCompaniesSelectDialogData,
    private insuranceCompanyService: InsuranceCompanyService,
    private fb: FormBuilder,
    private contractService: ContractService,
    private snack: MatSnackBar,
    private utilsService: UtilsService,
  ) {
    this.contractObject = data.contractObject;

    insuranceCompanyService.getAllInsuranceCompanies()
      .subscribe((result: CountedAndPaginated<InsuranceCompany>) => {
        this.insuranceCompanies = result.items;
        this.loadAssetsInsuranceCompanies();
        this.loadLifeInsuranceCompanies();
      });

    this.contractObject.insuranceCompanies.forEach((contractInsuranceCompany: ContractInsuranceCompany) => {
      if (contractInsuranceCompany.signed && contractInsuranceCompany.sent) {
        this.currentInsuranceCompanyIds.push(contractInsuranceCompany.insuranceCompany.id);
      } else {
        if (contractInsuranceCompany.disabled) {
          return;
        }

        this.toCheckInsuranceCompanyIds.push(contractInsuranceCompany.insuranceCompany.id);
      }

    });

    this.contractInsuranceCompaniesForm = fb.group({
      insuranceCompanies: this.insuranceCompaniesControl = fb.control(this.toCheckInsuranceCompanyIds),
    });
  }

  private loadAssetsInsuranceCompanies(): void {
    const companies = this.insuranceCompanies.filter((insuranceCompany: InsuranceCompany) => {
      return insuranceCompany.type.key === INSURANCE_TYPE_ASSETS
        && !insuranceCompany.inactive
        && (!insuranceCompany.parent || insuranceCompany.parent.id === insuranceCompany.id)
        ;
    });

    this.assetsInsuranceCompanies = [
      [...companies].splice(0, 9),
      [...companies].splice(9, 10),
      [...companies].splice(19)
    ];
  }

  private loadLifeInsuranceCompanies(): void {
    const companies = this.insuranceCompanies.filter((insuranceCompany: InsuranceCompany) => {
      return insuranceCompany.type.key === INSURANCE_TYPE_LIFE
        && !insuranceCompany.inactive
        && (!insuranceCompany.parent || insuranceCompany.parent.id === insuranceCompany.id)
        ;
    });

    this.lifeInsuranceCompanies = [
      [...companies].splice(0, 6),
      [...companies].splice(6, 5),
      [...companies].splice(11)
    ];
  }

  public save(): void {
      this.dialogRef.close(this.insuranceCompaniesControl.value);
  }

  public cancel(): void {
    this.dialogRef.close();
  }
}
